import React from "react";
import * as Icons from "react-feather";

function DangerAlert(props) {
    return (
        <>
            <div className="col-xl-3 sweetalert">
                <div className="card border-0">
                    <div className="alert alert-danger border border-danger mb-0 p-3">
                        <div className="d-flex align-items-start">
                            <div className="me-2">
                                <Icons.AlertOctagon className="flex-shrink-0"/>
                            </div>
                            <div className="text-danger w-100">
                                <div className="fw-semibold d-flex justify-content-between">Danger Alert</div>
                                <div className="fs-12 op-8 mb-1">{props.alert.message}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DangerAlert;
